<script>
  import { blocklist, text, richtext, image, url, exists } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;

  export let colors = ['darkblue', 'darkblue', 'darkblue', 'darkblue', 'darkblue', 'darkblue']
</script>

<style>
  .services .service-box.darkblue:hover {
	background: #1d54b6;
  }
</style>

<section id="services" class="services">
  <div class="container" data-aos="fade-up">
    <header class="section-header">
      <h2>{text(block, 'preheadline')}</h2>
      <p>{text(block, 'headline')}</p>
    </header>
    <div class="row gy-4 mb-3 justify-content-center">
      {#each blocklist(block, 'services') as item, i}
      <div class=" col-md-6 col-xl-4 " data-aos="fade-up" data-aos-delay="200">
        <div class="service-box {colors[i%6]}">
          <!-- <i class="ri-discuss-line icon"></i> -->
          <img class="mb-2 img-fluid" style="max-height: 300px;" src="{image(item, 'icon', [50, 50])}" alt="">
          <h3 style="height: 5em;">{text(item, 'title')}</h3>
          <p>{@html richtext(item, 'body')}</p>
          {#if exists(item, 'link')}
          <a href="{url(item, 'link')}" class="read-more" use:link>
            <span>{text(item, 'link')}</span> <i class="bi bi-arrow-right"></i>
          </a>
          {/if}
        </div>
      </div>
      {/each}
    </div>
  </div>
</section>
